import { render, staticRenderFns } from "./WidgetCommission.vue?vue&type=template&id=7f58692b"
import script from "./WidgetCommission.vue?vue&type=script&lang=js"
export * from "./WidgetCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports